import React, { Component } from 'react';
import { OutcomeTile } from 'web-ui-components/lib/layout/content';
import { Content } from '../../infrastructure/content';
class ApplicationSubmissionPage extends Component {
  render() {
    return (
      <form>
        <Content>
          {({ applicationSubmissionBodyHeader, applicationSubmissionBodyText }) => (
            <OutcomeTile.Success
              bodyText={applicationSubmissionBodyText}
              headingText={applicationSubmissionBodyHeader}
            />
          )}
        </Content>
      </form>
    );
  }
}

export default ApplicationSubmissionPage;
